import api from "@/lib/api";

// Closed app-audio endpoints only (Vocab card, AccentCoach phrase, curriculum item). Never browser speech.
const clips = new Map();

export async function playAppAudio(path) {
  if (!clips.has(path)) {
    const r = await api.post(path, null, { responseType: "blob" });
    clips.set(path, URL.createObjectURL(r.data));
  }
  const a = new Audio(clips.get(path));
  await a.play();
  return a;
}
